import { useTheme } from '@mui/material/styles';
import useClientMediaQuery from 'utils/useClientMediaQuery';

// assets
import DesktopView from './DesktopView';
import MobileView from './MobileView';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const matchDownMobileView = useClientMediaQuery(theme.breakpoints.down(1050), { defaultMatches: false });

    return !matchDownMobileView ? <DesktopView /> : <MobileView />;
};

export default Header;
